import { PACKAGE_NOT_EDITABLE_QUEUE_STATUSES, PACKAGE_EDITABLE_QUEUE_STATUSES } from 'types';

export const isPackageEditable = ({ queue, isFinCoUser = false }: { queue?: any; isFinCoUser?: boolean }) => {
  return isFinCoUser || !queue || PACKAGE_EDITABLE_QUEUE_STATUSES.has(queue?.status);
};

export const shouldShowPackageUnderReviewAlert = ({
  queue,
  isFinCoUser = false,
}: {
  queue?: any;
  isFinCoUser?: boolean;
}): boolean => {
  return !isFinCoUser && PACKAGE_NOT_EDITABLE_QUEUE_STATUSES.has(queue?.status);
};

export const PACKAGE_IN_REVIEW_QUEUE_ALERT_MESSAGE =
  'This package cannot be edited as it is currently ready for a Palmetto QC Tech to review. If you need to make any changes, add files, or update data, please reach out to us via Chat and a member of the QC Team can assist you.';
